import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

// utils
import { setPreventEvent } from "utils/event";

export const Popdown = ({ onRender, open, onClose, childFunc, ...props }) => {
  const self = useRef();

  const eventHandler = {
    close: (event) => {
      setPreventEvent(event);
      if (self.current) self.current.classList.remove("focus");
      if (onClose) {
        setTimeout(() => {
          onClose(false);
        }, 250);
      }
    },
    preventEvent: (event) => {
      setPreventEvent(event);
    },
  };

  useEffect(() => {
    childFunc.current = (e) => eventHandler.close(e);
  }, []);

  useEffect(() => {
    if (open && self.current) {
      setTimeout(() => {
        self.current.classList.add("focus");
        if (onRender) onRender(self.current);
      }, 100);
    }
  }, [open]);

  return open
    ? ReactDOM.createPortal(
        <Wrapper
          ref={self}
          className={props.className}
          visible={open}
          onClick={eventHandler.close}
          {...props}
        >
          <div onClick={eventHandler.preventEvent}>{props.children}</div>
        </Wrapper>,
        document.body
      )
    : null;
};

const Wrapper = styled.div`
  & {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    visibility: hidden;
    opacity: 0;
    z-index: 16;
    touch-action: none;
    transition: visibility 0.25s, opacity 0.25s;
    -webkit-overflow-scrolling: touch;
  }
  & > div {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0;
    background-color: white;
    box-sizing: border-box;
    transform: translateY(-100%);
    transition: transform 0.25s;
  }
  &.focus {
    visibility: visible;
    opacity: 1;
  }
  &.focus > div {
    transform: translateY(0);
  }

  & .top h3 {
    margin-bottom: 15px;
    line-height: 1;
  }
  & .bottom {
    margin-top: 15px;
  }
`;

export default Popdown;
